import { SvgIcon } from '@mui/material';

export default function NeedlMark(props) {
  return (
    <SvgIcon viewBox="0 0 32 32" {...props}>
      <path
        d="M16 11.8v13.85"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2.8"
      />
      <path
        d="m14.62 25.1 1.38 3.15 1.38-3.15"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.35"
      />
      <ellipse
        cx="16"
        cy="8.65"
        rx="2.25"
        ry="3.1"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.25"
      />
      <path
        d="M13.78 8.9C9.08 9.7 6 12.02 6 14.9c0 2.66 2.3 4.58 5.1 4.58 2.28 0 4.08-1.25 4.9-3.32"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.9"
        opacity="0.42"
      />
    </SvgIcon>
  );
}
